import { render, staticRenderFns } from "./EdmForm.vue?vue&type=template&id=3345bc5a&"
import script from "./EdmForm.vue?vue&type=script&lang=js&"
export * from "./EdmForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports